<template>
  <div id='my'>
        <MyPanel >
            <div class='baseinfo'> 
               <div class='baseinfo-icon'>
                    <div class='baseinfo-icon-imgcon' v-if="uinfo.headimg"> <img :src="uinfo.headimg" class="baseinfo-icon-img" alt=""/> </div>
               </div>
               <div class='baseinfo-profile'>
                    <div class='baseinfo-title'>{{uinfo.username}}</div>
                    <div class='baseinfo-desc'>{{uinfo.levelname}}</div>
               </div> 
               <div class='baseinfo-setting'>
                    <van-icon name="setting-o" size="0.5rem" @click='goPage("/setting")'/>
               </div>     
           </div>
       </MyPanel>
       <MyPanel title='我的订单'>
            <PanelItem icon='waitpay'  title='待支付' url='/orderlist' paramstr='{"activeTab":"1"}' />
            <PanelItem icon='waitdelv' title='待发货' url='/orderlist' paramstr='{"activeTab":"2"}'/>
            <PanelItem icon='waitrecv' title='待收货' url='/orderlist' paramstr='{"activeTab":"3"}'/>
            <PanelItem icon='waitdone' title='已完成' url='/orderlist' paramstr='{"activeTab":"4"}'/>
       </MyPanel>
       <MyPanel title='我的应用'>
            <PanelItem icon='jf' title='积分中心' url="/points" />
            <PanelItem icon='dz' title='地址管理' url='/addresslist' paramstr='{"from":"my"}'/>
            <PanelItem icon='sc' title='推广素材' @click="showTips" />
            <PanelItem icon='bm' title='活动报名' url='/trainlist'/>
            <PanelItem icon='yhq' title='优惠券' url="/couponlist"/>
            <PanelItem icon='gywm' title='关于我们' url='/article/7' />
            <PanelItem icon='upload' title='资质图片上传' url='/zzupload' />
            <div class='empty'></div>
       </MyPanel>
       <MyPanel title='服务工具'>
            <PanelItem icon='gzzx' title='规则中心' url='/rules'/>
            <PanelItem icon='tjr' title='我的推荐人' url='/mymanager'/>
            <PanelItem icon='kh' title='我的客户' url='/myclient'/>
            <PanelItem icon='yq' title='邀请客户' @click="popShareSheet"/>
       </MyPanel>
       <van-popup v-model="showShare" position="bottom" :close-on-click-overlay="false" >
           <div class="sharebox">
                 <div class="btngroup">
                      <div class="btngroup-col" @click="doCopy">
                           <div class="shareicon"><img src="~@/assets/img/share4-1.png"/></div>
                           <div class="sharewords">复制优惠码</div>
                      </div>
                      <div class="btngroup-col" @click="doShare(1)">
                         <div class="shareicon"><img src="~@/assets/img/share4-2.png"/></div>
                         <div class="sharewords">微信朋友圈</div>
                    </div>
                    <div class="btngroup-col"  @click="doShare(2)">
                         <div class="shareicon"><img src="~@/assets/img/share4-3.png"/></div>
                         <div class="sharewords">微信好友</div>
                    </div>
                    <div class="btngroup-col" @click="doSavePic">
                         <div class="shareicon"><img src="~@/assets/img/share4-4.png"/></div>
                         <div class="sharewords">保存图片</div>
                    </div>
                 </div>
                 <div class="cancelbtn" @click="closeShare">取 消</div>
           </div>  
       </van-popup> 
       <ShareImg v-if='showShare' :headimg='uinfo.headimg' :qrcode='uinfo.sharecode' :username='uinfo.username' :mobile='uinfo.mobile'/>
       <van-overlay :show="showTipImg" @click="showTipImg = false">
          <div @click.stop>
            <div class="tip-block">
                <img src="~@/assets/img/sharetip.png" class="tip-block-img"/>
            </div>
          </div>
       </van-overlay>
  </div>
</template>
<script>

import MyPanel from '@/components/mypanel'
import PanelItem from '@/components/mypanel/panelitem'
import ShareImg from '@/components/shareimg'
import { Icon,Popup,Overlay} from 'vant';

export default {
   name: 'my',
   data(){
      return {
           uinfo:{headimg:'',username:'',levelname:'',idcode:''},
           showShare:false,
           showTipImg:false
      }
   }, 
   created(){
       this.getList() 
   },
   methods: {
      getList(){
          this.$post("/user/getUserInfo",{}).then((data)=>{
             if(data.result.success){
                   this.uinfo=data.result.info
             }
          })  
      },  
      goPage(url){
          this.$go(url)
      },
      popShareSheet(){
         this.showShare=true
      },
      closeShare(){
         this.showShare=false  
      },
      showTips(){
         this.$toast("很抱歉,此功能暂未开放")  
      },
      doCopy(){
          this.$copyText(this.uinfo.idcode.toString()).then(function () {
          }, function () {
          })
          this.showShare=false
          this.$toast("复制成功")
      },
      doSavePic(){
         this.showShare=false  
         this.$toast("请使用手机截屏保存图片")  
      },
      doShare(type){
           this.$post("/user/initWxShare",{url:location.href.split('#')[0]}).then((data)=>{
               if(data.result.info.iswx==1){
                    var wx = require('weixin-js-sdk');
                    const signPac=data.result.info.signPackage
                    wx.config({
                         appId: signPac.appId, 
                         timestamp: signPac.timestamp.toString(), 
                         nonceStr: signPac.nonceStr.toString(), 
                         signature: signPac.signature,
                         jsApiList: ['updateAppMessageShareData','updateTimelineShareData'] 
                    });
               
                    const share=data.result.info.share
                    if(type==2){
                         wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                              wx.updateAppMessageShareData({ 
                              title: share.title, 
                              desc: share.desc, 
                              link: share.link, 
                              imgUrl: share.imgUrl, 
                              success: function () {
                              }
                       })
                      });
                    }else if(type==1){
                         wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
                              wx.updateTimelineShareData({ 
                              title: share.title, 
                              link: share.link, 
                              imgUrl: share.imgUrl, 
                              success: function () {
                              }
                              })
                          });
                    }
                    this.showShare=false 
                    this.showTipImg=true 
               }else{
                    this.showShare=false 
                    this.$toast("请在微信中打开分享")
               }
           })
      }
   },
   components: {
        MyPanel,
        PanelItem,
        ShareImg,
        [Icon.name]:Icon,
        [Popup.name]:Popup,
        [Overlay.name]:Overlay
   }
}
</script>
<style scoped>
#my{background-color:#F6F6F6;min-height: 100vh;padding: 0.3rem;}
.baseinfo{display:flex;width:100%;}
.baseinfo-icon{padding: 0.25rem;}
.baseinfo-icon-img{border-radius: 50%;width:1.2rem;height:1.2rem;}
.baseinfo-profile{text-align: left;padding: 0.25rem;}
.baseinfo-setting{margin-left:auto;}
.baseinfo-title{font-size:0.5rem;padding-left: 0.1rem;font-size:0.35rem;}
.baseinfo-desc{font-size:0.15rem;padding-left: 0.1rem;padding-top:0.1rem;font-size:0.4rem;}
.sharebox{border-top-left-radius: 0.2rem;border-top-right-radius: 0.2rem;display: flex;width:100%;background-color: #fff;flex-flow: column nowrap;}
.btngroup{display: flex;padding-bottom: 0.35rem;height:3rem;align-items: center;}
.btngroup-col{display: flex;flex-flow: column nowrap;flex:0 0 25%;}
.shareicon{padding: 0.58rem;padding-bottom: 0.2rem;}
.shareicon img{width:100%;}
.sharewords{font-size: 0.25rem;color:#333;}
.cancelbtn{background-color: #f0f0f0;color:#999999;font-size: 0.3rem;display: flex;height: 1rem;justify-content: center;align-items: center;}
.tip-block{display: flex;justify-content: flex-end;width:100%;}
.tip-block-img{width:320px;height:256px;}

.empty{display: flex;flex-direction: column;flex: 1 0 21%;padding: 0.25rem;}
</style>